import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Banner1 from '../shared/images/banner_hero-image1.png';
import Banner2 from '../shared/images/banner_hero-image2.png';
import Banner3 from '../shared/images/banner_hero-image3.png';
import { Wrapper } from 'components';
import { Link } from 'gatsby';

const StyledBanner = styled.div`
    height: 450px;
    // @media (max-width: ${props => props.theme.breakpoints.s}) {
    //     height: 625px;
    // }
`;

const StyledSlide = styled.div`
    height: 450px;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    z-index: -10;
`;

const StyledTitleContainer = styled.div`
    width: 100%;
    position: absolute;
    top: 10rem;
    z-index: 10;
    // @media (max-width: ${props => props.theme.breakpoints.s}) {
    //     top: 33rem;
    // }
`;

const StyledTitle = styled.h1`
    background-color: ${props => props.theme.colors.darkBlue};
    color: ${props => (props.theme.colors.white)};
    width: 55%;
    font-size: 3rem;
    line-height: 140%;
    @media (max-width: ${props => props.theme.breakpoints.l}) {
        width: 65%;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        width: 75%;
    }
    @media (max-width: 603px) {
        line-height: 170%;
        width: 100%;
    }
    @media (max-width: 373px) {
        line-height: 140%;
        width: 100%;
    }
    &::before {
        content: "";
        background: ${props => props.theme.colors.darkBlue};
        position: absolute;
        height: 4.2rem;
        width: 50%;
        left: 0px;
        z-index: -1;
        @media (max-width: ${props => props.theme.breakpoints.m}) {
            width: 75%;
            height: 4.2rem;
        }
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            width: 100%;
            height: 4.2rem;
        }
        @media (max-width: 373px) {
            height: 7rem;
        }

    }
    &::after {
        content: "";
        background: ${props => props.theme.colors.opaqueBlue};
        position: absolute;
        height: 4.2rem;
        width: 20%;
        z-index: -1;
        @media (max-width: ${props => props.theme.breakpoints.l}) {
            width: 20%;
        }
        @media (max-width: ${props => props.theme.breakpoints.m}) {
            width: 25%;
        }
        @media (max-width: ${props => props.theme.breakpoints.s}) {
            width: 0%;
        }
    }
`;

const Tagline = styled.p`
    position: absolute;
    top: 10.7rem;
    /* padding-left: 2rem; */
    max-width: 37rem;
    max-width: 40rem%;
    word-wrap: break-word;
    font-size: 1.25rem;
    line-height: 100%;
    height: 2rem;
    @media (max-width: ${props => props.theme.breakpoints.l}) {
        top: 10.7rem;
        max-width: 35rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        top: 9.5rem;
        max-width: 20;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        max-width: 23rem;

        top: 11rem;
    }
    @media (max-width: 603px) {
        max-width:23rem;

        top: 11rem;

    }
    @media (max-width: 373px) {
        max-width: 20rem;
        top: 13.8rem;

    }
`;
// const Taglinee = styled.p`
//     width: 65%;
//     font-size: 1.25rem;
//     line-height: 100%;
//     height: 2rem;
//     color: yellow;
//     @media (max-width: ${props => props.theme.breakpoints.m}) {
//         width: 60%;
//     }
//     @media (max-width: ${props => props.theme.breakpoints.s}) {
//         width: 100%;
//     }
// `;

const CallToAction = styled.p`
    font-size-: 1.25rem;
    margin-top: 6rem;
    font-weight: 500;
    button {
        border: none;
        cursor: pointer;
        background-color: transparent;
        color: ${props => (props.theme.colors.black)};
    }
`;

const StyledLink = styled(Link)`
    font-weight: 400;
    font-style: normal;
`;

const StyledButton = styled.button`
    position: absolute;
    bottom: -7rem;
    color: ${props => props.theme.colors.black};
    background-color: ${props => props.theme.colors.white};
    padding: 10px 30px 10px 30px;
    border: 1px solid ${props => props.theme.colors.black};
    border-radius: 4px;
    cursor: pointer;
    -webkit-transition-duration: ${props => props.theme.transitionDuration};
    transition-duration: ${props => props.theme.transitionDuration};
    transition-timing-function: ease-in-out;
    -webkit-transition-timing-function: ease-in-out;
    margin-bottom: 2rem;
    &:hover {
        border: 1px solid ${props => props.theme.colors.darkBlue};
        background-color: ${props => props.theme.colors.darkBlue};
        color: ${props => props.theme.colors.white};
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        bottom: -11rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        visibility: hidden;
    }
`;

// const SlidingBackground = styled.div`
//     z-index: -10;
//     top: 100px;
//     // color: ${props => (props.theme.colors.white)};
//     background-color: ${props => (props.theme.colors.white)};
//     .slick-dots {
//         top: 0;
//         padding-top: 2rem;
//     }
//     .slick-dots li {
//         width: auto;
//         padding-left: 5%;
//         padding-right: 5%;
//         height: 10px;
//         @media (max-width: ${props => props.theme.breakpoints.s}) {
//             margin: 0;
//             padding-left: 0.25rem;
//             padding-right: 0.25rem;
//         }
//     }
//     .slick-active .page-title {
//         color: ${props => (props.theme.colors.orange)};
//         // border-bottom: 1px solid ${props => (props.theme.colors.orange)};
//     }
//     // h1 {
//     //     // margin-bottom: 2rem;
//     //     // font-size: 1.4rem;
//     //     // line-height: 40px;
//     //     // border-bottom: 1px solid ${props => (props.theme.colors.white)};
//     //     background-color: ${props => props.theme.colors.darkBlue};
//     //     color: ${props => (props.theme.colors.white)};
//     //     position: absolute;
//     //     // left: 50px;
//     //     top: 150px;
//     //     // top: 0;
//     //     // left: 10px;
//     //     // max-width: ${props => props.theme.maxWidth};
//     // }
// `;

// const SlideBody = styled.div`
//     margin-top: 1rem;
// `;

// const SlideInner = styled.div`
//     max-width: ${props => props.theme.maxWidth};
//     margin: 0 auto;
//     padding: 0 2rem;
//     @media (max-width: ${props => props.theme.breakpoints.m}) {
//         padding: 0 1.5rem;
//     }
//     padding: 2em 0 3rem 0;
//     @media (max-width: ${props => props.theme.breakpoints.m}) {
//         padding: 0;
//     }
//     h1 {
//         // margin-bottom: 2rem;
//         // font-size: 1.4rem;
//         // line-height: 40px;
//         // border-bottom: 1px solid ${props => (props.theme.colors.white)};
//         background-color: ${props => props.theme.colors.darkBlue};
//         color: ${props => (props.theme.colors.white)};
//     }
//     button {
//         border: none;
//         cursor: pointer;
//         background-color: transparent;
//         color: ${props => (props.theme.colors.black)};
//     }
// `;

// const SlideText = styled.div`
//     max-width: 40%;
// //   line-height: 1.4;
// //   max-width: 95%;
// //   margin-bottom: 2rem;
// //   font-size: 3.2rem;
// //   p {
// //     display: inline;
// //     padding: 0;
//     // background-color: ${props => props.theme.colors.darkBlue};
//     // color: ${props => props.theme.colors.white};
//     // font-style: oblique;
// //   }
// `;

export default class HeroSlides extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        const { slides } = this.props;
        const pages = [
            {
                Image: Banner1,
                Tagline: "We solve complex business problems through human centred design"
            }
        ];
        {/*}
            {
                Image: Banner2,
                Tagline: "Our data-driven UX solutions enhance performance, increase efficiency and improve the way you work."
            },
            {
                Image: Banner3,
                Tagline: "We’ve designed and built hundreds of apps to transform businesses"
            }
        ];*/}
        const slideCards = pages.map((page, i) => {
            let StyledSlideInstance = styled(StyledSlide)`
                background: url("${page.Image}") no-repeat;
                background-position: center center;
                background-size: cover;
                @media (max-width: ${props => props.theme.breakpoints.l}) {
                    background-position: 85% center;
                }
                @media (max-width: ${props => props.theme.breakpoints.m}) {
                    background-position: 85% center;
                }
                @media (max-width: ${props => props.theme.breakpoints.s}) {
                    background-position: 75% center;
                }
            `;
            return (
                <StyledSlideInstance key={i} >
                  <Wrapper>
                  <Tagline>{page.Tagline.toUpperCase()}</Tagline>
                  </Wrapper>
                </StyledSlideInstance>
            );
        });
        const settings = {
            autoplay: true,
            autoplaySpeed: 6000,
            dots: false,
            infinite: true,
            speed: 1000,
            slideToShow: 1,
            slidesToScroll: 1
        };
        return (
            <StyledBanner>
                <StyledTitleContainer>
                    <Wrapper>
                        <StyledTitle>{slides.title.text}</StyledTitle>
                        {/*<Taglinee>{slides.tagline.text.toUpperCase()}</Taglinee>*/}
                    </Wrapper>
                </StyledTitleContainer>
                <Slider {...settings}>
                    {slideCards}
                </Slider>
            </StyledBanner>);
    }
}

HeroSlides.propTypes = {
    slides: PropTypes.object.isRequired,
};
